export default (date: Date): string => {
  if (isNaN(date.getDate())) return '';

  const monthArr = [
    'января',
    'февраля',
    'марта',
    'апреля',
    'мая',
    'июня',
    'июля',
    'августа',
    'сентября',
    'октября',
    'ноября',
    'декабря',
  ];

  return `${date.getDate()} ${monthArr[date.getMonth()]} ${date.getFullYear()}`;
};
